import { Auth0Provider } from "@auth0/auth0-react";
import { Outlet, useNavigate } from "react-router-dom";
import { Routes } from "src/config/routes";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

const Auth0ProviderWithRedirectCallback = ({ ...props }) => {
  const navigate = useNavigate();

  if (!(domain && clientId && redirectUri && audience)) {
    return <div>App Auth setup required</div>;
  }

  const onRedirectCallback = (appState?: any, user?: any) => {
    console.log("Auth0 callback with appState:", appState);
    const targetUrl = appState?.returnTo || Routes.CONNECTIONS;
    console.log("Redirecting to:", targetUrl);
    navigate(targetUrl);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
      {...props}
    >
      <Outlet />
    </Auth0Provider>
  );
};

export default Auth0ProviderWithRedirectCallback;
